<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="结款方ID" :value="1"></el-option>
                            <el-option label="结款方名称" :value="2"></el-option>
                            <el-option label="合同编号" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                    <el-select v-model="params.amountType" placeholder="请选择" size="small">
                        <el-option label="不限制金额" :value="1"></el-option>
                        <el-option label="仅看有当前未结款的" :value="2"></el-option>
                        <el-option label="仅看有历史已结款的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                    <el-select v-model="params.sortType" placeholder="请选择" size="small">
                        <el-option label="优先展示当前未结款最多的" :value="1"></el-option>
                        <el-option label="仅看展示历史有结款最多的" :value="2"></el-option>
                        <el-option label="仅看展示总销售最多的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="userType" label="结款方身份" min-width="90">
                    <template slot-scope="scope">
                        {{$userType.get(scope.row.userType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="结款方ID"></el-table-column>
                <el-table-column prop="name" label="结款方名称" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="goodsContractSn" label="合同编号" min-width="120"></el-table-column>
                <el-table-column prop="saleAmountFormat" label="总销售"></el-table-column>
                <el-table-column prop="unPlayAmountFormat" label="当前未结款"></el-table-column>
                <el-table-column prop="playAmountFormat" label="历史已结款"></el-table-column>
                <!-- <el-table-column prop="busDiscountFormat" label="已承担优惠"></el-table-column> -->
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/goodsReceivablesAudit/audi/createAudi') &&  scope.row.unPlayAmount > 0"
                            type="text"
                            size="small"
                            icon="el-icon-tickets"
                            @click="dataView(scope.row.id)"
                            >结款</el-button>
                        <el-button
                            v-if="$utils.have('/goodsReceivablesAudit/audi/list') && scope.row.playAmount > 0"
                            type="text"
                            size="small"
                            icon="el-icon-view"
                            @click="view(scope.row.id)"
                            >结款记录</el-button>    
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo: 1,
    amountType: 1,
    searchValue: '',
    searchType:  1,
    sortType: 1,
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                amountType: parseInt(this.$route.query.amountType || 1),
                searchValue: this.$route.query.searchValue || '',
                searchType:  parseInt(this.$route.query.searchType || 1),
                sortType: parseInt(this.$route.query.sortType || 1),
            },
            listLoading: false,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/goodsReceivablesAudit/audi/user/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
         //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        view(id){
            this.$router.push({
                path: '/finance/goods/settlement/detail',
                query: {
                    searchValue: id,
                },
            });
        },
        dataView(id){
           this.$router.push({
                path: `/finance/goods/settlement/list/${id}`,
                query: {
                    v: this.$utils.uuid(),
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            }); 
        }    
    }
}
</script>